// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.rentterms.UpdateRentTermsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UpdateRentTermsWebApiRequestDto, UpdateRentTermsWebApiResponseDto } from '../..';

export const UpdateRentTermsWebApiHandler_updateRentTerms_Path = '/api/web/v1/rentTerms/updateRentTerms';

/**
 * Update rent terms
 */
export const UpdateRentTermsWebApiHandler_updateRentTerms = (
  postData: UpdateRentTermsWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UpdateRentTermsWebApiRequestDto, UpdateRentTermsWebApiResponseDto>(
    {
      endpoint: UpdateRentTermsWebApiHandler_updateRentTerms_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
